module.exports = function() {
  return new Worker(__webpack_public_path__ + "abf7c0d3b3e746af4876.worker.js");
};